<template>
  <div class='mars-ape-layout-header'>
    <!--<Snow></Snow>-->
    <div v-if='bannerShow' class='imgs' :title='bannerTitle' :style="{ width:isCollapse?'100%':'90%' , }">
      <img :src='bannerImg' />
    </div>

    <div class='header-left'>
      <div class='header-nav-logo'>
        <a href='/home'>
          <img :src='siteInfo.logo_url||logo_header' :alt='siteInfo.web_name||"星象仪"' />
        </a>
      </div>
    </div>

    <div class='header-middle'>
      <TopMenu @isMore='isMore' :navMenus='navMenus' />
    </div>

    <div class='header-right'>
      <div class='isMore'>
        <MoreBtn :navMenus='navMenus'></MoreBtn>
      </div>
      <div>
        <!-- <LogisticsSearch></LogisticsSearch> -->
        <!--        <HelpSearch></HelpSearch>-->
      </div>

      <div class='right-notice'>
        <!--       系统通知广播-->
        <NotifyBroadcast @recvNotify='recvNotify'></NotifyBroadcast>
        <!--       查看系统消息-->
        <el-link @click='notifyPage'>
          <el-badge :value='notifyTotal' class='notify-total' type='primary'>
            <i class='el-icon-bell'></i>
          </el-badge>
        </el-link>
      </div>
      <el-dropdown @command='handleCommand'>
        <span class='right-account'>
          <!--          <div class="festival_cat ">-->
          <!--            <img :src="festival_cat">-->
          <!--          </div>-->
          <!--圣诞帽-->
          <span class='right-account-avatar'>
            <img :src='avatar' alt='avatar' style='border-radius: 50%; object-fit: fill' />
          </span>
          <span class='right-account-name' :title="userInfo['role_name']">
            {{ userInfo['nickname'] }}
          </span>
          <i class='el-submenu__icon-arrow el-icon-arrow-down'></i>
        </span>

        <el-dropdown-menu slot='dropdown'>
          <el-dropdown-item disabled command=''>
            <i class='el-icon-user'></i>
            <span>{{ userInfo['role_name'] }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided command='user-workbench'>
            <i class='el-icon-reading'></i>
            <span>工作台</span>
          </el-dropdown-item>
          <el-dropdown-item divided command='user-profile'>
            <i class='el-icon-service'></i>
            <span>个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item divided command='logout'><i class='el-icon-attract'></i><span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import BreadCrumb from '@/components/BreadCrumb'
import logo_header from '@/assets/festival/logo_sider-sd.png'
import avatar from '@/assets/avatar.png'
import WsTag from '@/components/WsTag'
import NotifyBroadcast from '@/pages/notify/NotifyBroadcast'
import festival_cat from '@/assets/festival/hat.png'
// import DelayNotify from '@/pages/business/DelayNotify'
import TopMenu from '@/layouts/TopMenu'
import Snow from '@/components/Style/snow.vue'
import MoreBtn from '@/layouts/MoreBtn.vue'
import menuApi from '@/api/menu_setting'
import BonusEdit from '@/pages/performance/bonus/BonusEdit.vue'
import bannerImg from '@/assets/festival/banner.png'
import wmbn from '@/assets/festival/wmbn.png'
// import LogisticsSearch from '@/layouts/LogisticsSearch.vue'

export default {
  computed: {
    ...mapGetters(['userInfo', 'notifyTotal', 'isCollapse','siteInfo'])
  },
  data() {
    return {
      avatar: avatar,
      festival_cat: festival_cat,
      logo_header: logo_header,
      name: '星象仪',
      // siteInfo: {
      //   logo: logo_header,
      //   name: '星象仪'
      // },

      dialogNotifyVisible: false, //商务逾期提醒框
      moreBtn: false,
      navMenus: [],
      env: false,
      bannerImg: bannerImg,
      borderTopColor: '#fff7f8',
      bannerTitle: '',
      bannerShow: false

    }
  },
  components: {
    BonusEdit,
    TopMenu,
    BreadCrumb,
    NotifyBroadcast,
    WsTag,
    Snow,
    MoreBtn,
    // LogisticsSearch
    // DelayNotify,
  },
  methods: {
    ...mapMutations(['handleUserInfo', 'changeNotifyTotal', 'handleRoutePath']),
    // 处理下拉菜单指令
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.handleLogout()
          break
        case 'user-profile':
          this.$router.push('/user/profile_edit')
          break
        case 'user-workbench':
          this.$router.push('/profile/workbench')
          break
        //   user-workbench
      }
    },
    // 处理退出
    handleLogout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` })
        // location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    notifyPage() {
      // this.$router.push('/notify')
      window.location.href = '/notify'
    },
    async getNotifyUnreadTotal() {
      const { total } = await this.$api.getNotifyTotal({})
      this.changeNotifyTotal(total)
    },
    recvNotify() {
      this.getNotifyUnreadTotal()
    },
    isMore(value) {
      this.moreBtn = value
    },

    bindNotifyMessage() {
      // 绑定事件-新消息接收处理
      if (this.$globalWs.ws) {
        this.$globalWs.ws.on('ev_new_message', (msg, data) => {
          this.$notify.success({
            title: '新消息提示',
            message: '您有新的消息，请注意查收！',
            onClick: () => {
              this.msg = true
            }
          })
          // if (data.length > this.msgList.length) {
          //   this.$notify.success({
          //     title: '新消息提示',
          //     message: '您有新的消息，请注意查收！',
          //     onClick: () => {
          //       this.msg = true
          //     }
          //   })
          // }
          this.msgList = data
        })
      }

    },
    async fetchMenuTree() {
      try {
        const res = await menuApi.getMenuTree()
        const list = Array.isArray(res) ? res : Object.values(res || {})
        this.navMenus = this.filterActiveMenus(list)
      } catch (e) {
        console.error('获取菜单树失败', e)
      }
    },
    filterActiveMenus(menus) {
      return menus
        .filter(item => String(item.status) === '1')
        .map(item => {
          const filteredChildren = item.children ? this.filterActiveMenus(item.children) : []
          if (item.children && item.children.length > 0 && filteredChildren.length === 0) {
            return null
          }
          return { ...item, children: filteredChildren }
        })
        .filter(Boolean)
    },
    getFestival() {
      // let today = new Date().toLocaleDateString()
      const date = new Date()
      const month = date.getMonth() + 1
      const day = date.getDate()
      if (month === 3 && (day === 8)) {
        this.bannerImg = wmbn
        this.borderTopColor = '#f4c7c8'
        this.bannerTitle = '三八妇女节快乐！'
        this.bannerShow = true
      }
    }
  },
  mounted() {
    this.getFestival()
    this.fetchMenuTree()
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    this.handleUserInfo(userInfo)
    // 头像
    if (this.userInfo.avatar) this.avatar = this.userInfo.avatar
  },
  created() {
  }

}
</script>

<style lang='scss' scoped>

.mars-ape-layout-header {
  height: 64px;
  width: 100%;
  min-width: 1024px;
  background: #fff;
  display: flex;
  align-items: center;
}

.mars-ape-layout-header > .header-right {
  height: 64px;
  line-height: 64px;
  width: 260px;
  min-width: 240px;
  flex-shrink: 0;
  display: flex;
}

.mars-ape-layout-header > .header-left {
  display: flex;
  flex-shrink: 0;
}

.mars-ape-layout-header > .header-middle {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
}

.mars-ape-layout-header > .header-left > .header-index-trigger {
  font-size: 20px;
  // height 64px
  cursor: pointer;
  transition: all .3s, padding 0s;
  padding: 10px 20px;
}

i.header-index-trigger:hover {
  background: rgba(0, 0, 0, .025);
}

.header-right .right-account, .header-right .right-notice {
  margin: 0 6px;
  display: inline-block;
  transition: all .3s;
  cursor: pointer;
  color: rgba(0, 0, 0, .65);
  margin-left: 12px;
}

.right-notice .el-badge {
  line-height: 30px;
}

.right-account-avatar {
  width: 30px;
  // line-height 48px
  display: inline-block;
  // margin 10px 8px 10px 0
  vertical-align: top;
  //border 1px solid #b8bec3
  margin: 0 12px;
}


.right-account-avatar > img {
  width: 100%;
  display: block;
  //border 1px solid #b8bec3
  margin-top: calc(100% - 15px);
}

.right-account-name {
  font-size: 14px;
}

.right-notice:hover, .right-account:hover {
  background: rgba(0, 0, 0, .025);
}

.el-dropdown-menu__item {
  padding: 5px 12px;
  line-height: 22px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
}

.el-dropdown-menu__item > .iconfont {
  margin-right: 8px;
}

.el-dropdown-menu {
  padding: 4px 0;
  margin: 0;
}

.el-dropdown-menu__item--divided {
  padding-top: 0;
  line-height: 28px;
}

.el-dropdown-menu__item--divided::before {
  margin: 0 -12px;
}

.el-dropdown-menu.el-popper {
  min-width: 160px;
  top: 56px !important;
}

.el-popper .popper__arrow {
  border-width: 0;
}

.el-popper .popper__arrow::after {
  border-width: 0;
}
</style>

<style scoped lang='scss'>

/**
      消息通知数的图标样式
       */
.header-nav-logo {
  margin-left: 1px;
  padding: 8px;
  height: 100%;
  display: flex;
  align-items: center;
}

.header-nav-logo img {
  max-width: 100%;
  max-height: 48px;
  object-fit: contain;
  display: block;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.right-account {
  width: 130px;
}

.notify-total {
  /*margin-top: 10px;*/
  margin-right: 5px;
  font-size: 1.3rem;
}

.header-middle {
  height: 100%;
  display: flex;
  overflow: hidden;
}

.isMore {
  width: 50px;
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

@media (min-width: 1024px) {
  .mars-ape-layout-header > .header-left {
    width: 220px;
    min-width: 220px;
  }
}

@media (max-width: 1024px) {
}

.imgs {
  //border: 1px solid red;
  position: absolute;
  z-index: 1;
  top: -12px;
  width: 100%;
  height: 30px;
  overflow: hidden;

  > img {
    display: block;
    //width: 150%;
    //height: 30px;

    position: absolute;
  }
}
</style>
